export const MIN_GLOBAL_SEARCH_LENGTH = 3

export const MAX_SEARCH_LENGTH = 200

export const SEARCH_DEBOUNCE_MS = 400

export const RESULT_PAGE_SEARCH_DEBOUNCE_MS = 800

export const SEARCH_DRAFT_SETTLE_MS = 3000

export const TRUNCATE_LENGTH_DESKTOP = 300

export const TRUNCATE_LENGTH_MOBILE = 150

export const ITEMS_PER_PAGE = 15

export const SORT_ORDER_OPTIONS = [
  { label: 'Relevans', value: 'relevance' },
  { label: 'Nyeste først', value: 'newest' },
  { label: 'Eldste først', value: 'oldest' },
] as const satisfies Array<{ label: string, value: string }>

export const SEARCH_TIPS = [
  'Sjekk at søkeordene er stavet riktig',
  'Prøv med alternative stavemåter eller nøkkelord',
  'Fjern eventuelle filter du har valgt',
] as const satisfies Array<string>

export const CONTENT_TYPE_OPTIONS = {
  'Lov og lovkommentar': {
    nodeTypes: ['law', 'chapter', 'section', 'subsection', 'del', 'legal_commentary', 'legal_commentary_section'],
    group: 'law',
  },
  'Tidsskrift': {
    nodeTypes: ['journal_article', 'journal_section', 'journal_editorial'],
    group: 'journal',
  },
  'Fagbok': {
    nodeTypes: ['book', 'book_page', 'book_chapter'],
    group: 'book',
  },
  'Fagartikkel': {
    nodeTypes: ['academic_article', 'academic_article_section'],
    group: 'academic',
  },
  'Forfatter': {
    nodeTypes: ['author'],
    group: 'author',
  },
} as const satisfies Record<string, { nodeTypes: readonly string[], group: string }>

/**
 * Specific display labels for nodeTypes shown in search results
 * More specific than facet group labels (e.g., "Tidsskriftartikkel" vs "Tidsskrift")
 */
export const NODE_TYPE_DISPLAY_LABELS = {
  law: 'Lov og lovkommentar',
  journal_article: 'Tidsskriftartikkel',
  journal_editorial: 'Tidsskriftartikkel',
  journal: 'Tidsskrift',
  journal_publisher: 'Forlag',
  book: 'Fagbok',
  academic_article: 'Fagartikkel',
  author: 'Forfatter',
} as const satisfies Record<string, string>

export const VISIBLE_FILTER_ITEMS_THRESHOLD = 10
